import { render, staticRenderFns } from "./DocCode.vue?vue&type=template&id=55584ebd&"
import script from "./DocCode.vue?vue&type=script&lang=js&"
export * from "./DocCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports